import { Component, OnInit } from '@angular/core';
import { ClientForListing } from '../../../../core/models/clients/client-for-listing.model';
import { ClientService } from '../../../../core/services/client.service';
import { NotificationService } from '../../../../shared/components/notifications/notification.service';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { DeleteConfirmDialogComponent } from '../../../../shared/components/delete-confirm-dialog/delete-confirm-dialog.component';
import { ClientRequestFilter } from '../../../../core/models/clients/client-request-filter.model';
import { AttachmentsModalComponent } from '../../../../shared/components/attachments-modal/attachments-modal.component';
import { AttachmentOverviewDto2 } from '../../../../core/models/attachments/attachment-overview-2.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-client-list',
  standalone: false,
  templateUrl: './client-list.component.html',
  styleUrl: './client-list.component.css',
})

export class ClientListComponent implements OnInit {
  clients: ClientForListing[] = [];
  isLoading = false;

  currentPage = 0;
  pageSize = 10;
  totalItems = 0;

  searchTerm: string | undefined = undefined;

  constructor(
    private clientService: ClientService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    private router: Router,
  ) { }

  ngOnInit(): void {
    // Restore persisted search and pagination for this page
    const savedSearch = sessionStorage.getItem('clients.list.search');
    const savedPage = sessionStorage.getItem('clients.list.page');
    const savedPageSize = sessionStorage.getItem('clients.list.pageSize');

    this.searchTerm = savedSearch !== null ? (savedSearch || undefined) : this.searchTerm;
    this.currentPage = savedPage !== null ? parseInt(savedPage, 10) || 0 : this.currentPage;
    this.pageSize = savedPageSize !== null ? parseInt(savedPageSize, 10) || this.pageSize : this.pageSize;

    this.loadClients();
  }

  loadClients(): void {
    this.isLoading = true;
    const apiPage = this.currentPage + 1;

    const filter: ClientRequestFilter = {
      page: apiPage,
      pageSize: this.pageSize,
      ...(this.searchTerm !== undefined && { search: this.searchTerm })
    };
    
    this.clientService.getPaginatedClients(filter).subscribe({
      next: ({ data, pagination }) => {
        this.clients = data;
        this.totalItems = pagination.totalItems;
        this.pageSize = pagination.itemsPerPage;
        this.currentPage = pagination.currentPage - 1;
        this.isLoading = false;
      },
      error: () => {
        this.notificationService.showError('Failed to load clients');
        this.isLoading = false;
      }
    });
  }

  onSearchChange(): void {
    this.currentPage = 0;
    // Persist current search value per page
    sessionStorage.setItem('clients.list.search', this.searchTerm || '');
    sessionStorage.setItem('clients.list.page', this.currentPage.toString());
    sessionStorage.setItem('clients.list.pageSize', this.pageSize.toString());
    this.loadClients()
  }

  clearSearch(): void {
    this.searchTerm = undefined;
    this.currentPage = 0;
    sessionStorage.removeItem('clients.list.search');
    sessionStorage.setItem('clients.list.page', this.currentPage.toString());
    sessionStorage.setItem('clients.list.pageSize', this.pageSize.toString());
    this.loadClients()
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    // Persist pagination on change
    sessionStorage.setItem('clients.list.page', this.currentPage.toString());
    sessionStorage.setItem('clients.list.pageSize', this.pageSize.toString());
    this.loadClients();
  }
  deleteClient(id: number): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '400px',
      data: { itemName: 'this client' }
    });
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.clientService.softDeleteClient(id).subscribe({
          next: () => {
            this.notificationService.showSuccess('Client deleted successfully');
            this.loadClients();
          },
          error: () => this.notificationService.showError('Failed to delete client')
        });
      }
    });
  }

    openAttachmentsModal(attachments: AttachmentOverviewDto2[], client: ClientForListing): void {
      const dialogRef = this.dialog.open(
        AttachmentsModalComponent,
        {
          width: '800px',
          data: attachments
        }
      );
      if (dialogRef.componentInstance) {
        dialogRef.componentInstance.clientId = client.id;
        dialogRef.componentInstance.attachmentType = 'Client';
      }
      dialogRef.afterClosed().subscribe(() => {
        const modalInstance = dialogRef.componentInstance;
        if (modalInstance && modalInstance.attachments) {
          client.attachments = modalInstance.attachments;
        }
      });
    }

    
}
